export const GET_ALL_TEMPLATES_DATA = 'GET_ALL_TEMPLATES_DATA';
export const GET_PERSONALIZATION_CATEGORY_DATA = 'GET_PERSONALIZATION_CATEGORY_DATA';
